import type { InvoiceStatus } from '@/entities/invoice'
import { Button } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'
import { toast } from '@/shared/ui/toast'
import { useClaimInvoicePayment, useDeclineInvoiceClaim, usePayInvoice } from '../api/pay'

interface InvoiceActionsProps {
  invoiceId: string
  status: InvoiceStatus
  isEmployee: boolean
}

// Действия над счётом по статусу и роли:
// - заказчик, issued → «Оплатил» (claim-payment);
// - сотрудник, issued → «Оплачен» (pay);
// - сотрудник, payment_claimed → «Подтвердить оплату» (pay) + «Отклонить» (decline).
// Оплаченный счёт действий не имеет.
export function InvoiceActions({ invoiceId, status, isEmployee }: InvoiceActionsProps) {
  const pay = usePayInvoice()
  const claim = useClaimInvoicePayment()
  const decline = useDeclineInvoiceClaim()

  if (!isEmployee) {
    if (status !== 'issued') return null
    return (
      <Button
        variant="secondary"
        size="sm"
        disabled={claim.isPending}
        onClick={() =>
          claim.mutate(invoiceId, {
            onSuccess: () => toast.success('Оплата отмечена, ждём подтверждения'),
            onError: () => toast.error('Не удалось отметить оплату'),
          })
        }
      >
        <Icon name="check" size={16} />
        Оплатил
      </Button>
    )
  }

  if (status === 'paid') return null

  const payBtn = (
    <Button
      variant="secondary"
      size="sm"
      disabled={pay.isPending}
      onClick={() =>
        pay.mutate(invoiceId, {
          onSuccess: () => toast.success('Счёт оплачен'),
          onError: () => toast.error('Не удалось отметить оплату'),
        })
      }
    >
      <Icon name="check" size={16} />
      {status === 'payment_claimed' ? 'Подтвердить оплату' : 'Оплачен'}
    </Button>
  )

  if (status === 'payment_claimed') {
    return (
      <div className="flex items-center gap-2">
        {payBtn}
        <Button
          variant="ghost"
          size="sm"
          disabled={decline.isPending}
          onClick={() =>
            decline.mutate(invoiceId, {
              onSuccess: () => toast.success('Оплата отклонена'),
              onError: () => toast.error('Не удалось отклонить'),
            })
          }
        >
          <Icon name="close" size={16} />
          Отклонить
        </Button>
      </div>
    )
  }

  return payBtn
}
